var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeadsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16895 9.9974C9.16895 10.2184 9.25674 10.4304 9.41302 10.5867C9.5693 10.7429 9.78126 10.8307 10.0023 10.8307C10.2233 10.8307 10.4353 10.7429 10.5915 10.5867C10.7478 10.4304 10.8356 10.2184 10.8356 9.9974C10.8356 9.77638 10.7478 9.56442 10.5915 9.40814C10.4353 9.25186 10.2233 9.16406 10.0023 9.16406C9.78126 9.16406 9.5693 9.25186 9.41302 9.40814C9.25674 9.56442 9.16895 9.77638 9.16895 9.9974Z",
    stroke: "#1D2D3E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16895 9.9974C9.16895 10.2184 9.25674 10.4304 9.41302 10.5867C9.5693 10.7429 9.78126 10.8307 10.0023 10.8307C10.2233 10.8307 10.4353 10.7429 10.5915 10.5867C10.7478 10.4304 10.8356 10.2184 10.8356 9.9974C10.8356 9.77638 10.7478 9.56442 10.5915 9.40814C10.4353 9.25186 10.2233 9.16406 10.0023 9.16406C9.78126 9.16406 9.5693 9.25186 9.41302 9.40814C9.25674 9.56442 9.16895 9.77638 9.16895 9.9974Z",
    stroke: "url(#paint0_linear_1798_40741)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0026 5.83594C9.17852 5.83594 8.37293 6.08031 7.68773 6.53815C7.00253 6.99599 6.46847 7.64673 6.15311 8.40809C5.83774 9.16945 5.75523 10.0072 5.916 10.8155C6.07677 11.6237 6.47361 12.3662 7.05633 12.9489C7.63905 13.5316 8.38148 13.9284 9.18973 14.0892C9.99798 14.25 10.8358 14.1675 11.5971 13.8521C12.3585 13.5367 13.0092 13.0027 13.4671 12.3175C13.9249 11.6323 14.1693 10.8267 14.1693 10.0026",
    stroke: "#1D2D3E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0026 5.83594C9.17852 5.83594 8.37293 6.08031 7.68773 6.53815C7.00253 6.99599 6.46847 7.64673 6.15311 8.40809C5.83774 9.16945 5.75523 10.0072 5.916 10.8155C6.07677 11.6237 6.47361 12.3662 7.05633 12.9489C7.63905 13.5316 8.38148 13.9284 9.18973 14.0892C9.99798 14.25 10.8358 14.1675 11.5971 13.8521C12.3585 13.5367 13.0092 13.0027 13.4671 12.3175C13.9249 11.6323 14.1693 10.8267 14.1693 10.0026",
    stroke: "url(#paint1_linear_1798_40741)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8362 2.54676C9.29123 2.37344 7.7306 2.6845 6.37017 3.43691C5.00974 4.18932 3.91674 5.34589 3.24237 6.74665C2.568 8.1474 2.34558 9.7231 2.60589 11.2558C2.86619 12.7885 3.59635 14.2024 4.69537 15.302C5.79439 16.4015 7.20794 17.1324 8.7405 17.3935C10.2731 17.6546 11.8489 17.4329 13.25 16.7593C14.6511 16.0856 15.8082 14.9932 16.5613 13.6331C17.3144 12.2731 17.6262 10.7126 17.4537 9.1676",
    stroke: "#1D2D3E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8362 2.54676C9.29123 2.37344 7.7306 2.6845 6.37017 3.43691C5.00974 4.18932 3.91674 5.34589 3.24237 6.74665C2.568 8.1474 2.34558 9.7231 2.60589 11.2558C2.86619 12.7885 3.59635 14.2024 4.69537 15.302C5.79439 16.4015 7.20794 17.1324 8.7405 17.3935C10.2731 17.6546 11.8489 17.4329 13.25 16.7593C14.6511 16.0856 15.8082 14.9932 16.5613 13.6331C17.3144 12.2731 17.6262 10.7126 17.4537 9.1676",
    stroke: "url(#paint2_linear_1798_40741)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5024 5V7.5H15.0024L17.5024 5H15.0024V2.5L12.5024 5Z",
    stroke: "#1D2D3E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5024 5V7.5H15.0024L17.5024 5H15.0024V2.5L12.5024 5Z",
    stroke: "url(#paint3_linear_1798_40741)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5024 7.5L10.0024 10",
    stroke: "#1D2D3E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5024 7.5L10.0024 10",
    stroke: "url(#paint4_linear_1798_40741)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1798_40741",
    x1: 10.0023,
    y1: 9.16406,
    x2: 10.0023,
    y2: 10.8307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6FB5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1982F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1798_40741",
    x1: 10.0026,
    y1: 5.83594,
    x2: 10.0026,
    y2: 14.1693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6FB5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1982F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1798_40741",
    x1: 10,
    y1: 2.5,
    x2: 10,
    y2: 17.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6FB5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1982F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1798_40741",
    x1: 15.0024,
    y1: 2.5,
    x2: 15.0024,
    y2: 7.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6FB5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1982F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1798_40741",
    x1: 11.2524,
    y1: 7.5,
    x2: 11.2524,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6FB5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1982F2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadsIcon);
export default __webpack_public_path__ + "static/media/leads-icon.88cbcc9b6c0c5546e910cbf781d174c8.svg";
export { ForwardRef as ReactComponent };